export default "__VITE_ASSET__a73c6cb4__"